import React, { useState } from "react";
import useSubscriptions from "@/hooks/useSubscriptions";
import MessageScrubberPanel from "./MessageScrubbing";
import AgentIdlePanel from "./AgentIdle";
import CustomStatusPanel from "./CustomStatuses";
import SecurityPanel from "./Security";
import IpBlockingPanel from "./IpBlocking";
import IpBlockingAuditPanel from "./IpBlockingAudit";
import ContactPanelSettingsPanel from "./ContactPanel";
import ReportSettingsPanel from "./ReportSettings";
import AdminActivityLogPanel from "./ActivityLog";

type Tab =
  | "settings"
  | "security"
  | "blocking"
  | "audit"
  | "customStatuses"
  | "agentIdle"
  | "activityLog"
  | "contactPanel"
  | "reports";

export default function MessagingSettings() {
  const { subscription } = useSubscriptions();
  const hasIpBlocking = subscription?.enableIpBlocking;
  const hasCustomStatuses = subscription?.enableCustomStatuses;
  const hasReports =
    subscription?.enableConversationReports ||
    subscription?.enableAgentDashboard ||
    subscription?.enableCustomThresholds ||
    subscription?.enableCustomDashboards ||
    subscription?.enableScheduleAdherenceReports;

  const [activeTab, setActiveTab] = useState<Tab>("settings");

  const tabClass = (tab: Tab) =>
    `pb-2 text-sm font-medium border-b-2 whitespace-nowrap cursor-pointer ${
      activeTab === tab
        ? "border-cornflower-blue-500 text-cornflower-blue-600"
        : "border-transparent text-slate-500 hover:text-slate-700"
    }`;

  return (
    <div className="h-full overflow-y-auto">
      <div className="border-b border-slate-200 px-6 pt-4">
        <div className="flex gap-4 overflow-x-auto">
          <button
            className={tabClass("settings")}
            onClick={() => setActiveTab("settings")}
          >
            Message Scrubbing
          </button>
          <button
            className={tabClass("agentIdle")}
            onClick={() => setActiveTab("agentIdle")}
          >
            Agent Idle
          </button>
          {hasCustomStatuses && (
            <button
              className={tabClass("customStatuses")}
              onClick={() => setActiveTab("customStatuses")}
            >
              Custom Statuses
            </button>
          )}
          <button
            className={tabClass("security")}
            onClick={() => setActiveTab("security")}
          >
            Security & SSO
          </button>
          {hasIpBlocking && (
            <button
              className={tabClass("blocking")}
              onClick={() => setActiveTab("blocking")}
            >
              IP Blocking
            </button>
          )}
          {hasIpBlocking && (
            <button
              className={tabClass("audit")}
              onClick={() => setActiveTab("audit")}
            >
              IP Audit Log
            </button>
          )}
          <button
            className={tabClass("contactPanel")}
            onClick={() => setActiveTab("contactPanel")}
          >
            Contact Panel
          </button>
          {hasReports && (
            <button
              className={tabClass("reports")}
              onClick={() => setActiveTab("reports")}
            >
              Reports
            </button>
          )}
          <button
            className={tabClass("activityLog")}
            onClick={() => setActiveTab("activityLog")}
          >
            Activity Log
          </button>
        </div>
      </div>
      {activeTab === "settings" && <MessageScrubberPanel />}
      {activeTab === "agentIdle" && <AgentIdlePanel />}
      {activeTab === "customStatuses" && hasCustomStatuses && (
        <CustomStatusPanel />
      )}
      {activeTab === "security" && <SecurityPanel />}
      {activeTab === "blocking" && hasIpBlocking && <IpBlockingPanel />}
      {activeTab === "audit" && hasIpBlocking && <IpBlockingAuditPanel />}
      {activeTab === "contactPanel" && <ContactPanelSettingsPanel />}
      {activeTab === "reports" && hasReports && <ReportSettingsPanel />}
      {activeTab === "activityLog" && <AdminActivityLogPanel />}
    </div>
  );
}
